"use client";

import React from "react";
var __jsx = React.createElement;
import { cn } from "@lib/cn";
import { resetScrollPos } from "@lib/util/scroll-ops";
import { useEffect } from "react";
import MaxWidthContainer from "./muscle-max-width";
export function PageContainer(_ref) {
  let {
    children,
    className,
    style,
    noDefaultClassName,
    fullWidth
  } = _ref;
  useEffect(() => {
    resetScrollPos();
  }, []);
  return __jsx(MaxWidthContainer, {
    fullWidth: fullWidth
  }, __jsx("div", {
    className: cn(!noDefaultClassName && "global-page global-responsive-horizontal-paddings", fullWidth && "w-full max-w-[1440px]", className),
    style: style
  }, children));
}
export default PageContainer;